module.exports = __webpack_public_path__ + "img/icon2.aa7acb68.png";